import { withStyles } from "@material-ui/core/styles";
import Redirect from "./Redirect";
import styles from "./styles";

export default withStyles(styles)(Redirect);
